export default class DealerModuleProvider {
  constructor(settings) {
    this.apiUrl = settings.apiUrl;
    this.culture = settings.culture;
    this.numberOfResults = settings.numberOfResults;
  }

  // RETURNS Promise
  getAllDealers(categories) {
    var self = this;
    var queryFilter = this.getFilterQuery(categories);
    return this.sendGetRequest(
      'GET',
      '/odata/dealers/?lang=' +
        self.culture +
        '&$expand=categories' +
        queryFilter
    );
  }

  // RETURNS Promise
  getCategories() {
    var self = this;
    return this.sendGetRequest('GET', '/odata/categories?lang=' + self.culture);
    // return new Promise(function(resolve) {
    //   resolve([
    //     {
    //       id: 1,
    //       codename: 'groothandel',
    //       displayname: 'Groothandel',
    //       tooltip:
    //         'Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst.'
    //     },
    //     {
    //       id: 2,
    //       codename: 'installateur',
    //       displayname: 'Installateur',
    //       tooltip:
    //         'Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst.'
    //     },
    //     {
    //       id: 3,
    //       codename: 'dealer',
    //       displayname: 'Dealer',
    //       tooltip:
    //         'Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst.'
    //     }
    //   ])
    // })
  }

  // RETURNS Promise
  search(location, categories, scope = null, searchTerm = null) {
    var self = this;
    var parameters = {
      latitude: location.lat,
      longitude: location.lng
    };
    if (scope != null) parameters.scope = scope;

    var queryFilter = this.getFilterQuery(categories);

    var query =
      "/odata/dealers/nearest(latitude='" +
      parameters.latitude +
      "',longitude='" +
      parameters.longitude +
      "')?$expand=categories" +
      queryFilter +
      '&$top=' +
      self.numberOfResults +
      '&$orderby=SortOrder' +
      '&lang=' +
      self.culture +
      `&searchTerm=${searchTerm}`;

    return this.sendGetRequest('GET', query);
  }

  getFilterQuery(categories) {
    var queryFilter = '';
    if (categories.length > 1) {
      queryFilter = '&$filter=Categories/any(cat: ';
      for (let i = 0; i < categories.length; i++) {
        if (i === 0) {
          queryFilter =
            queryFilter +
            `cat/DisplayName eq '${categories[i]}' or cat/CodeName eq '${categories[i]}'`;
        } else {
          queryFilter =
            queryFilter +
            ` or cat/DisplayName eq '${categories[i]}' or cat/CodeName eq '${categories[i]}'`;
        }
      }
      queryFilter = queryFilter + ')';
    } else if (categories.length > 0) {
      queryFilter = `&$filter=Categories/any(cat: cat/DisplayName eq '${categories}' or cat/CodeName eq '${categories}')`;
    }

    return queryFilter;
  }

  // RETURNS Promise
  sendGetRequest(method, controller, parameters = {}) {
    var self = this;
    return new Promise(function (resolve, reject) {
      var url = self.apiUrl + controller;
      for (var propertyName in parameters)
        url = url + '&' + propertyName + '=' + parameters[propertyName];

      var request = new XMLHttpRequest();
      request.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(request.response);
        } else {
          reject(new Error(JSON.stringify({
            status: this.status,
            statusText: request.statusText
          })));
        }
      };
      request.onerror = function () {
        reject(new Error(JSON.stringify({
          status: this.status,
          statusText: request.statusText
        })));
      };
      request.open(method, url, true);
      request.send();
    });
  }
}
